// extracted by mini-css-extract-plugin
export default {"minMax":"priceRange_minMax__K0iDf","header":"priceRange_header__f0wES","inputs":"priceRange_inputs__Guz12","min":"priceRange_min__A2rCc","max":"priceRange_max__koqPB"};